export enum DeviceOrigin {
  None = 0, // Default, wenn nicht spezifiziert bzw. 0 oder null
  App = 1, // Antrag wird in der App erstellt
  Portal = 2, // Antrag wird im Portal erstellt
}
